import { loadStripe } from "@stripe/stripe-js";
// const apiUrl = "https://api.relibuild.com";
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.href.includes("trycloudflare") ||
  window.location.href.includes("ngrok") ||
  window.location.hostname.includes("192") ||
  window.location.pathname.includes("ngrok");
const apiUrl = isLocalhost
  ? "http://localhost:3000"
  : "https://api.relibuild.com";
export const localPath = "https://api.relibuild.com";
// export const localPath = "http://localhost:3000";

export default apiUrl;
// const user = store.getState().UserProfile.user
// console.warn(user,"user..............")

export const stripePromise = loadStripe(
  "pk_live_51K6MBVAPzdvW0Lalca5t7QfATaFDZ3hPgoOc6E3A5eYC8Yyc7lNZutsjQGdv5Cxj2YCfjLju65W2gtyWeh5wdfFL00UFyNn7Xz",
);
export const stripePromiseTest = loadStripe(
  "pk_test_51K6MBVAPzdvW0Lal5Vs4TvDmBT6nkDvKhvY7IOgRHisl5Kd2Y7p55xwodWqqmutDLvIafVxpWpMYoBCuDLJNTteP00bRgIYRAk",
);
